import { render, staticRenderFns } from "./ReportesLectorEmailPatrocinadores.vue?vue&type=template&id=0a107da2&"
import script from "./ReportesLectorEmailPatrocinadores.vue?vue&type=script&lang=js&"
export * from "./ReportesLectorEmailPatrocinadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports